import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MarioGameCoreService } from './mario-game-core.service';
import { MarioGameSelectorComponent } from './mario-game-selector/mario-game-selector.component';

@NgModule({
  declarations: [MarioGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MarioGameCoreService],
  exports: [MarioGameSelectorComponent],
})
export class MarioGameCoreModule {}
